import { connect } from 'react-redux';
import { IState } from '../../store/';

import { IInfrastructureProps, Infrastructure } from './index';

function mapStateToProps(state: IState): IInfrastructureProps {
  return {
    offer: state.offerData.offer,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InfrastructureContainer = connect<IInfrastructureProps, any, any>(mapStateToProps)(Infrastructure);
